import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import api from "./api";

export async function exportExcel(params) {
  const res = await api.get("/export/excel", { params, responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  const cd = res.headers["content-disposition"] || "";
  const match = cd.match(/filename="?([^"]+)"?/);
  a.download = match ? match[1] : "SS_Sales_Analytics.xlsx";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function exportPdf(elementId, fileName = "SS_Sales_Analytics.pdf") {
  const el = document.getElementById(elementId);
  if (!el) throw new Error("Nothing to export");
  const canvas = await html2canvas(el, {
    scale: 1.5,
    backgroundColor: "#f8fafc",
    useCORS: true,
    logging: false,
    windowWidth: el.scrollWidth,
  });
  const imgData = canvas.toDataURL("image/jpeg", 0.9);
  const pdf = new jsPDF("p", "mm", "a4");
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const imgW = pageW;
  const imgH = (canvas.height * imgW) / canvas.width;
  let heightLeft = imgH;
  let position = 0;
  pdf.addImage(imgData, "JPEG", 0, position, imgW, imgH);
  heightLeft -= pageH;
  while (heightLeft > 0) {
    position -= pageH;
    pdf.addPage();
    pdf.addImage(imgData, "JPEG", 0, position, imgW, imgH);
    heightLeft -= pageH;
  }
  pdf.save(fileName);
}

const SORT_FIELD = { abv: "abv", abq: "abq", sales: "net_sales", bills: "bills", quantity: "net_qty" };

export function sortRows(rows, key, order) {
  const field = SORT_FIELD[key] || "abv";
  const dir = order === "asc" ? 1 : -1;
  return [...rows].sort((a, b) => {
    const av = a[field] == null ? -Infinity : a[field];
    const bv = b[field] == null ? -Infinity : b[field];
    return av < bv ? -1 * dir : av > bv ? 1 * dir : 0;
  });
}
